import api from '../helpers/api';

const initialState = {
  isLoading: false,
  wentToPost: false,
  questions: [
    {
      question: 'IDENTIFY_HATE_1',
      component: 'range',
      screen: 'rondo',
    },
    {
      question: 'IDENTIFY_HATE_2',
      component: 'range',
      screen: 'rondo',
    },
    {
      question: 'IDENTIFY_HATE_3',
      component: 'range',
      screen: 'rondo',
    },
    {
      question: 'DETECT_HATE_1',
      component: 'bool',
      screen: 'quiz',
    },
    {
      question: 'DETECT_HATE_2',
      component: 'multiple',
      condition: {
        // index: 3,
        index: 'prev',
        value: true,
      },
      options: [
        'SCHOOL',
        'HOME',
        'FRIENDS',
        'SOCIALMEDIA',
        'WORK',
        'OTHER',
      ],
      screen: 'quiz',
    },
    {
      question: 'DETECT_HATE_3',
      component: 'bool',
      screen: 'quiz',
    },
    {
      question: 'DETECT_HATE_4',
      component: 'multiple',
      condition: {
        // index: 5,
        index: 'prev',
        value: true,
      },
      options: [
        'SCHOOL',
        'HOME',
        'FRIENDS',
        'SOCIALMEDIA',
        'WORK',
        'OTHER',
      ],
      screen: 'quiz',
    },
    {
      question: 'DETECT_HATE_5',
      component: 'range',
      screen: 'cards',
    },
    {
      question: 'DETECT_HATE_6',
      component: 'range',
      screen: 'cards',
    },
    {
      question: 'REPORT_HATE_1',
      component: 'bool',
      screen: 'cards',
    },
    {
      question: 'REPORT_HATE_2',
      component: 'range',
      screen: 'cards',
    },
    {
      question: 'REPORT_HATE_3',
      component: 'bool',
      screen: 'quiz',
    },
    {
      question: 'SOURCES_0',
      component: 'range',
      screen: 'search',
    },
    {
      question: 'SOURCES_1',
      component: 'multiple',
      options: [
        'FORWARD',
        'CHECK',
      ],
      screen: 'search',
    },
    {
      question: 'SOURCES_2',
      component: 'bool',
      screen: 'search',
    },
    {
      question: 'SOURCES_3',
      component: 'multiple',
      condition: {
        index: 'prev',
        value: true,
      },
      options: [
        'MALDITA',
        'NEWTRAL',
        'EFE',
        'RTVE',
      ],
      screen: 'search',
    },
    {
      question: 'REVIEW_1',
      component: 'multiple',
      options: [
        'AT_SCHOOL',
        'BY_FRIENDS',
        'BY_SOCIAL',
        'BY_OTHERS',
      ],
    },
    {
      question: 'REVIEW_2',
      component: 'bool',
    },
    {
      question: 'REVIEW_3',
      component: 'bool',
    },
    {
      question: 'REVIEW_4',
      component: 'bool',
    },
    {
      question: 'REVIEW_5',
      component: 'bool',
    },
  ],
};

const getters = {
  byScreen: (state) => (screen) => state.questions.filter((item) => item.screen === screen),
  questionId: (state) => (question) => {
    for (let i = 0; i < state.questions.length; i += 1) {
      if (state.questions[i].question === question.question) {
        return i;
      }
    }

    return -1;
  },
};

const actions = {
  submit(store, { prepost, question, answer }) {
    if (!prepost || typeof answer === 'undefined' || typeof question !== 'number') {
      return false;
    }

    let cleanAnswer = answer;
    if (typeof answer !== 'string') {
      cleanAnswer = answer.toString();
    }
    return api.post('/evaluate', {
      prepost,
      question,
      answer: cleanAnswer,
    }).catch((e) => {
      console.error(e);
    });
  },
  dismissPost({ commit }) {
    commit('DISMISS_POST');
  },
  resetPost({ commit }) {
    commit('RESET_POST');
  },
};

const mutations = {
  DISMISS_POST(state) {
    state.wentToPost = true;
  },
  RESET_POST(state) {
    state.wentToPost = false;
  },
};

// Export store
export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
